import script from "./detail-collapse.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail-collapse.vue?vue&type=script&lang=ts&setup=true"

import "./detail-collapse.vue?vue&type=style&index=0&id=01898590&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01898590"]])

export default __exports__